<template>
  <div class="manager_dashboard">
  <user-menu />
  <div class="wrapper">
    <EnterpriseAdminSidebarMenu 
      :readOnly="isReadOnly"
    />
    <div class="content-wrapper">
      <div class="container-wrapper center">
        <div>
            <i class="fa fa-chevron-left modal-goback" @click="goToLocationWindow"></i>
          <h3 class="d-inline heading">{{ pageTitle }}</h3>
        </div>
        <div class="heading-seperator"></div>
        <div v-show="loading" class="loading_show"><div class="spinner-border text-danger"></div></div>
        <div v-if="loading === false">
          <div class="row mt-2">
            <div class="col-12 col-sm-9 col-md-9 col-lg-9 col-xl-9"> 
              <div class="row">
                <div class="col-12 col-sm-8 col-md-9 col-lg-10 col-xl-10">
                  <div class="mentee_name">{{ userTypeName }}: {{ menteeName }}
                    <div class="custom_hr"></div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-6 col-sm-8 col-md-9 col-lg-10 col-xl-10">
                  <div v-if="tasklists.length > 0">
                    <b-form-select v-model="tasklistId" :options="tasklists" style="margin-bottom: 0px !important" class="mb-3 col-md-12" @change="showAssessmentofTasklist()" />
                  </div>
                </div>
                <div class="col-6 col-sm-4 col-md-3 col-lg-2 col-xl-2">
                  <div v-if="tasklists.length > 0">
                  <button class="btn btn-primary btn-sm task-goal-btn" @click="redirectTaskGoal">Task Goals</button>
                  </div>
                </div>
              </div>
            </div>
            </div>
          </div>
          <div v-if="tasklists.length > 0">
            <div v-show="tasklists_loading" class="loading_show"><div class="spinner-border text-danger"></div></div>
            <div class="col-md-12 counter_subtask-list p-0" id="tasks">
              <flash-message autoHide variant="success"></flash-message>
              <div v-for = "(subtask, stindex) in subtasks" :key="stindex">
                <div class="subtask-wrapper">
                <h4 class="panel-title">
                  <b-link
                    v-b-toggle="'collapse-' + subtask.id"
                    >
                    <span class="counter_subtask-list__counter"></span>
                    {{ subtask.name }}
                  </b-link>
                </h4>
                <b-collapse v-bind:id="'collapse-' + subtask.id" class="mt-2 subtask-wrapper">
                  <b-card>
                    <div class="col-md-12 override-padding counter_heading-list">
                      <div v-for = "(heading, index) in subtask.headings" :key="index">
                        <b-link v-b-toggle="'collapse-' + subtask.id + '-' + heading.id" size="sm" class="sub-heading" @click="getFontIcon(subtask.id + '-' + heading.id)">
                          <span class="counter_heading-list__counter"></span>
                          {{ heading.name }}
                          <i class="fa fa-angle-down" :id="'angle-'+ subtask.id + '-' + heading.id" aria-hidden="true"></i>
                        </b-link>
                        <b-collapse v-bind:id="'collapse-' + subtask.id + '-' + heading.id" class="mt-2 task-wrapper">
                          <div class="col-md-12 override-padding counter_task-list">
                            <MenteeTaskList
                                :itemLength="heading.tasks.length" 
                                :allItems="heading.tasks"
                                :menteeId="menteeId"
                                :tasklistId="tasklistId"
                                :subTaskId="subtask.id"
                                :headingId="heading.id">
                            </MenteeTaskList>
                            <div style="clear: both;"></div>
                          </div>
                        </b-collapse>
                      </div>
                    </div>
                    <div class="col-md-12 override-padding counter_task-list task-wrapper">
                      <MenteeTaskList
                          :itemLength="subtask.tasks.length" 
                          :allItems="subtask.tasks"
                          :menteeId="menteeId"
                          :tasklistId="tasklistId"
                          :subTaskId="subtask.id"
                          headingId="">
                      </MenteeTaskList>
                    </div>
                    <div style="clear: both;"></div>
                  </b-card>
                </b-collapse>
              </div>
            </div>
          </div>
        </div>
        <div v-else class="noitems-custom-msg">No tasklist assigned for this mentee</div>
      </div>

      <EnterpriseAdminOverlaySidebar
              :isModalVisible="isModalVisible" 
              @close="closeSidebar"
              ref="location_sidebar" 
              :readOnly="isReadOnly" 
             />

    </div>
  </div>
  </div>
</template>

<script>
import router from '../../router/index';
import Vue from 'vue/dist/vue.esm';
import UserMenu from '../shared/user_menu.vue';
import GoBack from '../shared/goback.vue';
import custommodal from '../manager/custom_modal.vue';
import axios from 'axios';
import moment from 'moment';
import { store } from '../../store/store.js';
import AdminSidebarMenu from '../shared/admin_sidebar_menu.vue';
import MenteeTaskList from '../enterpriseadmin/mentee_task_list.vue';
import EnterpriseAdminSidebarMenu from '../shared/enterpriseadmin_sidebar_menu.vue';
import EnterpriseAdminOverlaySidebar from './enterpriseadmin_overlay_sidebar.vue';

Vue.filter('formatDate', function(value) {
  if (value) {
    return moment(String(value)).format('MMM DD, YYYY')
  }
});

export default {
  data: function () {
    return {
      'subtasks': [],
      isModalVisible: false,
      'history_title': '',
      'history_comment': '',
       loading: false,
       tasklists: [],
       tasklistId: '',
       menteeId: '',
       subTaskId: '',
       menteeName: '',
      'assessment_loading': false,
      tasklists_loading: false,
      repCount: 0,
      isReviewRepsModalVisible: false,
      isManager: false,
      pageTitle: '',
      program: '',
      userType: '',
      userTypeName: '',
      isModalVisible: false,
      accountId: '',
      userId: '',
      isReadOnly: false,
    }
  },
  methods: {
  showAssessmentofTasklist() {
     this.tasklists_loading = true;
     this.subtasks = [];
     axios.get('/desktop/mentees_tasklists_detail/' + this.userId + '/' + this.tasklistId + '/' + this.accountId)
      .then(response =>  {
          this.tasklists_loading = false;
          this.subtasks = response.data.subtasks;
          const mentee = response.data.mentee;
          this.getReviewRepsList(this.tasklistId);
      })
      .catch(function(error) {

      });
  },
  menteeRepititionApproval() {
    this.isReviewRepsModalVisible = true;
    const vmessage = 'hide_vmessage';
    this.$refs.review_reps_form.getScoreLists(vmessage);
  },
  getFontIcon(id) {
    if (document.getElementById('collapse-' + id).style.display == "") {
      document.getElementById('angle-'+ id).className = "fa fa-angle-down";
    } else {
      document.getElementById('angle-'+ id).className = "fa fa-angle-up";
    }
  },
  redirectTaskGoal() {
    router.push('/enterprise-admin/mentees-task-goals/' + this.accountId + '/' + this.userId + '?e4=' + this.tasklistId);
  },
  IsUserManager() {
    var roles = this.$store.state.roles;
    if(roles.indexOf('ROLE_ADMIN') > -1)
    {
      return true;
    }
    else {
      return false;
    }
  },
    goToLocationWindow() {
        this.isModalVisible = true;
        this.$refs.location_sidebar.accountId = this.accountId;
        this.$refs.location_sidebar.selectedComponent = 'UsersTab';
        this.$refs.location_sidebar.getLocationDetail(this.accountId);
    },
    closeSidebar() {
        this.isModalVisible = false;
    },
  },
  components: {
    UserMenu,
    GoBack,
    custommodal,
    AdminSidebarMenu,
    MenteeTaskList,
    EnterpriseAdminSidebarMenu,
    EnterpriseAdminOverlaySidebar,
  },
  created: function () {
    this.isManager = this.IsUserManager();
    this.loading = true;
    this.accountId = this.$route.params.account_id;
    this.userId = this.$route.params.user_id;
    axios.get('/enterprise-admin/mentees_tasklists', {
      params: {
        user_id: this.userId,
        account_id: this.accountId,
      }
    })
    .then(response =>  {
      this.loading = false;
      var tasklistArr = response.data;
      this.tasklistId = tasklistArr[0]['id'];
      for( var i=0; i< tasklistArr.length; i++) {
        var tasklistOption = {value:tasklistArr[i]['id'], text:tasklistArr[i]['name']};
        this.tasklists.push(tasklistOption);
      }

      var e4_val = this.$route.query.e4;
      if(typeof(e4_val) !==  "undefined") {
          this.tasklistId = e4_val;
      }
      this.showAssessmentofTasklist();
    })
    .catch(function(error) {

    });

    
    axios('/enterprise-admin/user-account-info/'+this.userId+'/'+this.accountId,
    {
      method: 'GET',
    })
    .then(response => {
      this.program = response.data.program;
      this.menteeName = response.data.user_name;
      this.userType = response.data.user_type;
      
      if (this.userType == "apprentice") {
        this.pageTitle = "Apprentice Assessment";
        this.userTypeName = "Apprentice";
      } else {
        this.pageTitle = "Mentee's Assessment";
        this.userTypeName = "Mentee";
      }
    })
    .catch(() => {
    });

    var roles = store.state.roles;
    if((roles.indexOf('ROLE_ADMIN') > -1) || (this.$store.state.switch_admin_username)) {
      this.admin = true;
    }

    if (this.$store.state.enterprise_type === 'Readonly') {
      this.isReadOnly = true;
    } else {
      if (this.$store.state.switch_admin_enterprise_isreadonly) {
        this.isReadOnly = true;
      } else {
        this.isReadOnly = false;
      }
    }

    

  },

  updated() {
   setTimeout(()=>{
    var e1_val = this.$route.query.e1;
    var e2_val = this.$route.query.e2;
    var e3_val = this.$route.query.e3;
    if(e1_val) {
      var ele = document.getElementById("collapse-" + e1_val);
      ele.style.display = 'block';
      var ele2 = ele.parentElement.getElementsByClassName("panel-title")[0].getElementsByTagName("a")[0];
      ele2.className = '';
      var ele1 = document.getElementById("collapse-" + e1_val + "-" + e2_val);
      ele1.style.display = 'block';
      document.getElementById(e3_val).scrollIntoView(false);
    }
   }, 300);
  },

}
</script>

<style scoped>
.back-btn-wrapper {
  width:100%;
  margin-left: 10px;
  margin-right: 0px;
}
.mentee_name {
  font-size: 19px;
  margin-bottom: 0px;
}
hr {
  margin: 10px auto;
}
.custom_hr {
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
  margin: 10px 0px;
  width: 100%;
}
.goReview{
  background-color: #FFF;
  border: 1px solid #00acee;
  border-radius: 10px;
  padding: 5px;
  line-height: 15px;
  margin: 20px 10px;
  float: right;
}
.goReview div {
  margin-left: 10px;
  float: left;
}
.review_count { 
  color: #00acee; 
  font-size: 24px; 
  margin-top: 6px; 
}
.review_text { 
  font-weight: 100;
  color: #7d7d7d;
}
.goRepsBtn, .goRepsBtn:active {
  color: #FFF; 
  background-color: #00acee !important;
  border: 1px solid #00acee !important;
  border-radius: 10px;
}
.goRepsGrayBtn, .goRepsGrayBtn:active {
  color: #FFF; 
  background-color: #7d7d7d !important;
  border: 1px solid #7d7d7d !important;
  border-radius: 10px;
}
.manageBtn, .manageBtn:active, .manageBtn:focus {
  color: #00acee !important;
  background-color: #FFF !important;
  border: 1px solid #00acee !important;
  border-radius: 10px;
  font-size: 13px;
  font-weight: 900;
  padding: 5px;
  line-height: 10px;
  width: 120px;
  margin-left: 10px;
}
.task-goal-btn {
  color: #00acee !important;
  background-color: #FFF !important;
  border: 1px solid #00acee !important;
  font-size: 13px;
  font-weight: 900;
  padding: 8px;
  width: 100%;
}
/* Small Devices */
@media (min-width: 320px) and (max-width: 576px) { 
  .goReview {
    float: left;
    margin-left: 16px;
  }
}
/* Iphone 5 */
@media (min-width: 320px) and (max-width: 576px) { 
  .manageBtn {
    width: 60px;
  }
}
@media (min-width: 375px) and (max-width: 601px) { 
  .manageBtn {
    width: 109px;
  }
}
/* Ipad */
@media (min-width: 768px) and (max-width: 1024px) { 
  .manageBtn {
    width: 89px;
  }
}
.modal-goback { font-size: 22px; margin: 5px 10px 0 0; cursor: pointer; }
</style>



// WEBPACK FOOTER //
// src/components/enterpriseadmin/mentees_task.vue